import React from "react";

const ReportedItems = () => {
  return (
    <div>
      <h1>reported Items</h1>
    </div>
  );
};

export default ReportedItems;
